import { useQuery } from '@tanstack/react-query'
import { redis } from '@/redis'
import { queryKeys } from '@/query-keys'
import { CHAIN_SUPPORTS_ADD_TO_DEX, getDexInfoFromDenom } from '@/config'
import { useSelectedDenom } from '../../../contexts/denom'
import { assert } from '@/utils'

const useDexPoolApyQuery = () => {
  const [denom] = useSelectedDenom()

  const dexInfo = getDexInfoFromDenom(denom)

  const handleRequest = async (): Promise<{ apy: number }> => {
    assert(dexInfo, 'Unable to fetch dex apy while disconnected.')

    // sheet_POOL_TOTAL_APR_stINJ/INJ
    const value = await redis.get<number>(`sheet_POOL_TOTAL_APR_st${dexInfo.coinDenom}/${dexInfo.coinDenom}`)

    return { apy: value ?? 0 }
  }

  return useQuery({
    queryKey: queryKeys.stakingModalDexPoolApyByDenom({ denom }),
    queryFn: handleRequest,
    enabled: CHAIN_SUPPORTS_ADD_TO_DEX[denom] && Boolean(dexInfo)
  })
}

export { useDexPoolApyQuery }
